import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackEvent = (event, page) => {
  // Fire and forget — do NOT block the user's click
  try {
    axios.post(`${API}/track`, {
      event,
      page: page || (typeof window !== "undefined" ? window.location.pathname : ""),
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "",
    }).catch(() => {});
  } catch {
    /* ignore */
  }
};
